import { mapActions } from "vuex";
export default {
    name: "archivme",
    data() {
        return {
            comment2Options:["未上传回单", "未邮寄回单", "超过时限"],
            comment3Options:["图片模糊", "回单信息与实际不符", "图片有误，请上传场地签收回单"],

            show: {
                BackOrder_Sure: false,
                BackOrder_Export: false,
                BackOrder_Look: false
            },
            exportLoading: false,
            pageLoading: false,
            pageData: [],
            alreadyQS: null,
            notQS: false,
            pageInitInfo: {
                pageSizes: [10, 20, 30, 40, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0
            },
            form: {
                receiptState: null,
                orderId: null,
                orderState: null,
                waybillNum: null,
                planDepartTmScope: null,
                srcCityName: null,
                destCityName: null,
                image: null,
                pageNum: 1,
                pageSize: null

            },
            details: {
                orderId: null,
                waybillNum: null,
                commentArr: [],
                comment2: null
            },
            receiptStates: [
                {
                    value: null,
                    label: '全部'
                },
                {
                    value: '8',
                    label: '待上传'
                },
                {
                    value: '1',
                    label: '待寄回'
                },
                {
                    value: '2',
                    label: '待签收'
                },
                {
                    value: '3',
                    label: '签收成功'
                },
                {
                    value: '4',
                    label: '签收失败'
                },
                {
                    value: '5',
                    label: '已驳回'
                }

            ],
            tableColunm: [// 列表
                {
                    prop: 'orderId',
                    label: '订单号',
                    width: 150,
                }, {
                    prop: 'outerOrderId',
                    label: '客户单号',
                    width: 150,
                },
                {
                    prop: 'receiptType',
                    width: 150,
                    label: '回单类型', formatter: function (row, column) {
                        if (row.receiptType == 1) {
                            return '电子回单';
                        }
                        if (row.receiptType == 2) {
                            return '电子+纸质回单';
                        }
                        return '/';
                    }
                },
                {
                    prop: 'receiptState',
                    label: '回单状态',
                    width: 120,
                    formatter: function (row, column) {
                        if (row.receiptState == 1 && row.receiptType == 1) {//电子
                            return '待上传';
                        } else if (row.receiptState == 1 && row.receiptType == 2) {
                            return '待寄回';
                        }

                        if (row.receiptState == 2) {//电子
                            return '待签收';
                        }

                        if (row.receiptState == 3) {
                            return '签收成功';
                        }
                        if (row.receiptState == 4) {
                            return '签收失败';
                        }
                        if (row.receiptState == 5) {
                            return '已驳回';
                        }
                    }
                },
                {
                    prop: 'waybillNum',
                    label: '物流单号',
                    width: 150
                },
                {
                    prop: 'srcCityName',
                    label: '发货城市',
                    width: 140
                },
                {
                    prop: 'destCityName',
                    label: '收货城市',
                    width: 120,
                },
                {
                    prop: 'planDepartTm',
                    label: '计划发车时间',
                    width: 150
                },
                {
                    prop: 'appTaskCompleTm',
                    label: '收车时间',
                    width: 150
                },
                {
                    prop: 'waybillNumInputTm',
                    label: '寄回时间',
                    width: 150,
                },
                {
                    prop: 'driverName',
                    label: '司机姓名/联系方式',
                    width: 220,
                    formatter: function (row, column) {
                        if (row.driverName && row.driverPhone) {
                            return row.driverName + '/' + row.driverPhone;
                        }
                        return "";
                    }
                },
            ],
            recpDialogVisible: false,
            recpImgUrl: [],
            srcList: "",
            currentPageData: null,
            picList: null,
            disapleUploadSpan: false,
            inputRecpDetail: true,
            recepTitle: '回单'
        }
    },
    watch:{
        alreadyQS:function(val){
            if(val == 1){
                this.details.comment2 = ''
            }
        }
    },
    methods: {
        ...mapActions([
            "getRecepListApi",
            "writeReceipt",
            "writeUnableBack",
            "postReceiptSign",
            "receiptExportApi",
            "postReject",
            "viewImgApi",
        ]),
         getImageUrl(val){
            this.srcList = ""
             this.viewImgApi({path: val})
                 .then(res => {
                     if (res) {
                         this.srcList = res.img;
                     } else {
                         this.$message({
                             type: 'error',
                             message: "图片加载失败"
                         });
                     }
                 }, response => {
                     this.$message({
                         type: 'error',
                         message: "图片加载失败"
                     });
                 });
        },
         previewImage(val){
            if(val.isViewBase === 1){
                this.getImageUrl(val.path)
            }else{
                 this.$nextTick(()=>{
                    this.srcList = "";
                    this.srcList=val.baseUrl;
                })
            }
        },
        onAddComment(item) {
            if (this.details.commentArr.indexOf(item) == -1) {
              this.details.commentArr.push(item)
            } else {
              this.details.commentArr.pop(item)
            }
            this.details.comment2 = this.details.commentArr.join(' ')
          },
        onExport() {
            let params = Object.assign({}, this.form)
            params.planSendTmBegin = this.form.planDepartTmScope[0];
            params.planSendTmEnd = this.form.planDepartTmScope[1];
            delete params.planDepartTmScope
            this.exportLoading = true
            
            this.receiptExportApi(params).then(res => {
                window.open(this.getHostUrl() + "/saas/orderCore/downLoadFile?objectName=" + res.filePath)
            }).catch(e => { }).finally(() => {
                this.exportLoading = false
            });
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        dialogOpenView(row) {
            let receiptStateText = null;
            this.alreadyQS = null;
            this.currentPageData = row;
            this.details.comment2 = row.comment;
            
            this.details.waybillNum = row.waybillNum;

            if (row.receiptState == 3) {
                receiptStateText = '(签收成功)';
                this.alreadyQS = '1'
                this.inputRecpDetail = true;
            }
            if (row.receiptState == 4) {
                this.inputRecpDetail = true;
                this.alreadyQS = '2'
                receiptStateText = '(签收失败)';
            }
            if (row.receiptState == 5) {
                this.inputRecpDetail = false;
                this.alreadyQS = '3'
                receiptStateText = '(已驳回)';
            }

            this.recepTitle = '纸质回单' + receiptStateText;
            this.recpDialogVisible = true;

            this.details.comment = '';

            let param = { 'requireId': row.orderId, 'srcCityCode': row.srcCityCode }
            this.writeReceipt(param).then(res => {
                this.recpImgUrl = []
                if (res.receiptInfo) {
                    this.recpImgUrl = res.receiptInfo;
                }
                this.disapleUploadSpan = this.recpImgUrl.length>0 ? false : true
            }).catch(e => {
                this.disapleUploadSpan = true;
            });

        },
        dialogOpen(row) {
            let receiptStateText = null;
            this.alreadyQS = null;
            this.currentPageData = row;
            this.details.comment2 = row.comment;
            this.details.commentArr = [];
            this.details.waybillNum = row.waybillNum;
            if (row.receiptState == 1 && row.receiptType == 1) {
                this.inputRecpDetail = false;
                receiptStateText = '(待上传)';
            } else if (row.receiptState == 1 && row.receiptType == 2) {
                this.inputRecpDetail = false;
                receiptStateText = '(待寄回)';
            }
            if (row.receiptState == 2) {
                this.inputRecpDetail = false;
                receiptStateText = '(待签收)';
            }
            if (row.receiptState == 3) {
                receiptStateText = '(签收成功)';
                this.inputRecpDetail = true;
            }
            if (row.receiptState == 4) {
                this.inputRecpDetail = true;
                receiptStateText = '(签收失败)';
            }
            if (row.receiptState == 5) {
                this.inputRecpDetail = false;
                receiptStateText = '(已驳回)';
            }
            this.recepTitle = '纸质回单' + receiptStateText;
            this.recpDialogVisible = true;

            this.details.comment = '';
            this.recpImgUrl = [];
            let param = { 'requireId': row.orderId, 'srcCityCode': row.srcCityCode }
            this.writeReceipt(param).then(res => {
                if (res.receiptInfo) {
                    this.recpImgUrl = res.receiptInfo;

                }
                this.disapleUploadSpan = this.recpImgUrl.length>0 ? false : true
            }).catch(e => {
                this.disapleUploadSpan = true;
            });

        },
        checkParam(temp) {
            if (temp.receiptType && temp.receiptType == 2) {
                let trim = this.details.waybillNum.trim();
                if (trim == '' || trim == null) {
                    return "请填写物流单号";
                }
                if (!this.checkRate(trim)) {
                    return "物流单号只能为数字和字母";
                }
                if (trim.length > 20 || trim.length < 8) {
                    return "物流单号长度不能小于8大于20";
                }
            }
            return null;
        },
        checkRate(nubmer) {
            var re = /^[0-9a-zA-Z]*$/g;
            if (!re.test(nubmer)) {
                return false;
            } else {
                return true;
            }
        },
        receiptSign() {//确认签收
            let temp = Object.assign({}, this.currentPageData);
            // 当前登陆用户工号
            let param = {
                "orderId": temp.orderId, "planDepartTm": temp.planDepartTm,
                "waybillNum": this.details.waybillNum,
                "comment": this.details.comment2,
            }
            if (this.alreadyQS == null) {
                this.$message({
                    type: "warning",
                    message: "请选择回单签收状态",
                });
                return;
            }
            if (this.alreadyQS == 1) {
                let checkParam1 = this.checkParam(temp);
                if (checkParam1 != null) {
                    this.$message({
                        type: "error",
                        message: checkParam1,
                    });
                    return;
                }
                this.$confirm('确认签收?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postReceiptSign(param).then(res => {
                        this.$notify({
                            type: 'success',
                            title: '提示',
                            dangerouslyUseHTMLString: true,
                            message: '操作成功！</br>订单号：<span style="font-weight: bold;color:#67C23A;">' + this.currentPageData.orderId +
                                '</span>',
                            duration: 3000
                        });
                        this.getPagaData()
                        this.handleClose()
                    }).catch(e => {

                    });
                }).catch(e => {

                });
            }

            if (this.alreadyQS == 2) {
                this.$confirm('请确认司机是否无法按照回单要求提供，点击确定将视为签收失败?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.writeUnableBack(param).then(res => {
                        this.$notify({
                            type: 'success',
                            title: '提示',
                            dangerouslyUseHTMLString: true,
                            message: '操作成功！</br>订单号：<span style="font-weight: bold;color:#67C23A;">' + this.currentPageData.orderId +
                                '</span>',
                            duration: 3000
                        });
                        this.getPagaData()
                        this.handleClose()
                    }).catch(e => {

                    });
                });
            }

            if (this.alreadyQS == 3) {
                this.$confirm('请确认是否驳回?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postReject(param).then(res => {
                        this.$notify({
                            type: 'success',
                            title: '提示',
                            dangerouslyUseHTMLString: true,
                            message: '操作成功！</br>订单号：<span style="font-weight: bold;color:#67C23A;">' + this.currentPageData.orderId +
                                '</span>',
                            duration: 3000
                        });
                        this.getPagaData()
                        this.handleClose()
                    }).catch(e => {

                    });
                });
            }

        },
        //司机无法寄回
        receiptUnableBack() {
            let temp = Object.assign({}, this.currentPageData);
            // 当前登陆用户工号
            let param = {
                "orderId": temp.orderId, "planDepartTm": temp.planDepartTm,
                "waybillNum": this.details.waybillNum,
                "comment": this.details.comment2,
            }
            this.$confirm('请确认司机是否无法按照回单要求提供，点击确定将视为签收失败?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.writeUnableBack(param).then(res => {
                    this.$notify({
                        type: 'success',
                        title: '提示',
                        dangerouslyUseHTMLString: true,
                        message: '操作成功！</br>订单号：<span style="font-weight: bold;color:#67C23A;">' + this.currentPageData.orderId +
                            '</span>',
                        duration: res
                    });
                    this.handleClose()
                }).catch(e => {

                });

            }).catch(() => {

            });
        },
        reset() {
            this.form.receiptState = null;
            this.form.orderId = null;
            this.form.orderState = null;
            this.form.waybillNum = null;
            this.form.planDepartTmScope = null;
            this.form.srcCityName = null;
            this.form.destCityName = null;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        rowDblclick(row) {
            // let param={
            //     consignorState:4,
            //     orderId:row.orderId,
            //     planDepartTm:row.planDepartTm,
            //     srcCityCode:row.srcCity
            // }
            // this.$emit("page", "订单管理列表", "ownerOrderManage", 200428);
            // this.$store.commit("setUnsettledShipperOrder",param);
        },
        // 每页展示多少条数据改变事件
        sizeChange(val) {
            this.pageInitInfo.pageSize = val;
            this.pageInitInfo.pageNumber = 1;
            this.getPagaData();
        },
        currentChange(val) {
            // alert(val)
            this.pageInitInfo.pageNumber = val;
            this.getPagaData();
        },
        queryPage() {
            if (!this.form.planDepartTmScope) {
                this.$message({
                    type: "warning",
                    message: "请选择计划发车时间范围",
                });
                return;
            }
            this.pageInitInfo.pageNumber = 1;
            this.getPagaData();
        },
        getPagaData() {
            this.form.pageNum = this.pageInitInfo.pageNumber;
            this.form.pageSize = this.pageInitInfo.pageSize;
            let param = JSON.parse(JSON.stringify(this.form));
            param.planSendTmBegin = this.form.planDepartTmScope[0];
            param.planSendTmEnd = this.form.planDepartTmScope[1];
            // param.planSendTmBegin="2019-05-31T16:00:00.000Z";
            // param.planSendTmEnd="2019-07-30T16:00:00.000Z"
            delete param.planDepartTmScope;

            this.getRecepListApi(param).then(res => {
                this.pageData = res.data.rows;
                this.pageInitInfo.total = res.data.totalCount;

            }).catch(e => {

            });

        },
        queryReceipt() {

        },
        handleClose(row) {
            this.recpDialogVisible = false;
            this.recpImgUrl = [];
            this.srcList = '';
            this.currentPageData = null;
            this.disapleUploadSpan = false;
        }
    },
    created: function () {
        let menuInterval = setInterval(() => {
            let map = JSON.parse(sessionStorage.getItem('menuMap'))
            if (map) {
                clearInterval(menuInterval)
                let submenuList = map['BackOrderManager'].split('-');
                submenuList.forEach((item, i) => {
                    this.show[item] = true;
                });
            }
        }, 30);
        let start = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);
        let end = new Date(new Date().getTime() + 18 * 24 * 60 * 60 * 1000);
        this.form.planDepartTmScope = [start, end]
    },
    mounted() {
        this.queryPage()
    }
}